import { PageScaffold } from "../../shared/ui/PageScaffold";

const adminLinks = [
  { to: "/t/:tenantSlug/teacher/admin", label: "管理ホーム" },
  { to: "/t/:tenantSlug/teacher/admin/policies", label: "ポリシー" }
];

export function AdminIntegrationsPage() {
  return (
    <PageScaffold
      title="Admin Integrations"
      description="外部連携設定画面のプレースホルダーです。"
      links={adminLinks}
    >
      <p>ここに integration 設定を表示します。</p>
    </PageScaffold>
  );
}
